import React from "react";
import CertificateLetter from "./Letters/CertificateLetter";

const CertificateMadrid = ({certificate}) => {

    return (
        <>
            <div className="card-body">
                <p><strong>Fecha</strong>: {certificate.date}</p>
                <p><strong>Número de registro</strong>: {certificate.num_certificate}</p>
                <p><strong>Dirección</strong>: {certificate.address}</p>
                <p><strong>Municipio</strong>: {certificate.municipality}</p>
                <p><strong>Codigo postal</strong>: {certificate.postal_code}</p>
                <p><strong>Zona climatica</strong>: {certificate.climatic_zone}</p>
                <p><strong>Consumo global</strong>: {certificate.final_consumption}</p>
                <p><strong>Emisiones </strong>: {certificate.emissions_co2}</p>
                <p><strong>Classificación consumo </strong>: <CertificateLetter
                    letter={certificate.ranking_consumption}/></p>
                <p><strong>Classificación emisiones </strong>:<CertificateLetter
                    letter={certificate.ranking_emissions_co2}/></p>
            </div>
        </>
    );
}


export default CertificateMadrid;